import { Box, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import PrePaidRequestDetail from "../../components/pages-components/pre-paid-request-detail/PrePaidRequestDetail";
import PrePaidRequestEmpty from "../../components/pages-components/pre-paid-request-empty/PrePaidRequestEmpty";
import { useOnUpdateUserEvents } from "../../hooks/firestoreHooks/eventListUpdateHook";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { getEventRequestThunk } from "../../store/events/eventThunk";
import palette from "../../theme/palette";
import { FONT_SECONDARY } from "../../theme/typography";
import "./prePaidRequests.scss";

const PrePaidRequests = () => {
	const dispatch = useAppDispatch();
	const [shouldStartUpdating, setShouldStartUpdating] = useState(false);
	const eventRequests = useAppSelector((state) => state.events.eventRequests);
	const fetchEventListData = useCallback(async () => {
		dispatch(getEventRequestThunk(null));
	}, [dispatch]);

	useEffect(() => {
		const getData = async () => {
			dispatch(getEventRequestThunk(null));
			setShouldStartUpdating(true);
		};
		getData();
	}, []);

	useOnUpdateUserEvents(shouldStartUpdating, fetchEventListData);
	return (
		<>
			<Helmet>
				<title> Pre-Paid Requests </title>
			</Helmet>
			<Box className="content">
				<Box className="pageLayoutPrePaidRequests prePaidPage">
					<Typography
						component="h1" sx={{ color: palette.secondary.main, fontWeight: 600, fontFamily: FONT_SECONDARY, fontSize: {
								xs: "20px",
								md: "32px",
							},
							mb: {
								xs: "16px",
								md: "24px",
							}, }}>
						Pre-Paid Requests
					</Typography>
					{eventRequests?.length > 0 ? (
						<>
							<PrePaidRequestDetail
								eventRequests={eventRequests}
							/>
						</>
					) : (
						<PrePaidRequestEmpty
							prePaidEmptyTitle="Pre-Paid Requests"
							prePaidEmptyDescription="You have no Pre-Paid Requests yet. Please come back later."
						/>
					)}
				</Box>
			</Box>
		</>
	);
};

export default PrePaidRequests;
